import React from 'react';
import {Tooltip, Fab} from '@mui/material';
import {AutoAwesome} from '@mui/icons-material';
import styled from 'styled-components';
import {EarlyFeatureAccessOptInDialog} from 'app/components/earlyFeatureAccess/EarlyFeatureAccessOptInDialog';
import {useEarlyAccessFeatures} from 'app/earlyAccess/useEarlyAccessFeatureManager';
import {COLORS} from '@fupa/fupa-uikit';
import hotspotAnimation from 'app/components/earlyFeatureAccess/HotspotAnimation';

const Container = styled.div`
  z-index: ${props => props.theme.zIndexFab};
  bottom: 7.5rem;
  right: 0;
  position: fixed;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  ${props => props.theme.desktopLayout`
    bottom: 4rem;
  `}

  ${props => props.theme.desktopLayoutWithFab`
    margin-left: ${props => props.theme.desktopContentWidth}px;
    right: unset;
  `};
`;

const HotspotWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Hotspot = styled.div`
  position: absolute;
  width: 52px;
  height: 52px;
  border: ${props => (props.pulsing ? `2px solid ${COLORS.fupaSecondary}` : 'none')};
  border-radius: 50%;
  animation: ${props => (props.pulsing ? hotspotAnimation : 'none')};
`;

const EarlyFeatureAccessFab = props => {
  const [open, setOpen] = React.useState(false);
  const [touched, setTouched] = React.useState(true);

  const {earlyAccessFeatures, submitConsentChanges} = useEarlyAccessFeatures();
  if (!earlyAccessFeatures.length) {
    return null;
  }

  const handleClose = () => {
    setOpen(false);
    submitConsentChanges();
  };
  const handleClick = () => {
    setOpen(true);
    setTouched(true);
  };

  return (
    <>
      <Container {...props}>
        <Tooltip title='Als Erster ausprobieren' placement='right'>
          <HotspotWrapper>
            <Hotspot pulsing={!touched} />
            <Fab
              sx={{margin: '1rem'}}
              color='secondary'
              onClick={handleClick}
              size='small'
              aria-label='early-feature-access'>
              <AutoAwesome />
            </Fab>
          </HotspotWrapper>
        </Tooltip>
      </Container>
      <EarlyFeatureAccessOptInDialog earlyAccessFeatures={earlyAccessFeatures} open={open} onClose={handleClose} />
    </>
  );
};
export default EarlyFeatureAccessFab;
